export class Phone {
  areaCode: string;
  number: string;
}
